import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { TOOLTIP_ACTIONS } from "../../../constants/tooltipText";
import { tableHeaderProps } from "../../../styled/props/tableProps";
import { dateFormat } from "../../../utils/general";

const Row = ({ address, user, confirmDelete }) => {
    return (
        <>
            <TableRow
                hover
                sx={{ "& > *": { borderBottom: "unset" } }}
                data-testid="addressRow"
            >
                <TableCell align="center">{address.ADDRESS}</TableCell>
                <TableCell align="center">
                    {dateFormat(address.creation_date)}
                </TableCell>
                <TableCell align="center">{user}</TableCell>
                <TableCell align="center" sx={{ pl: "0px", pr: "4px" }}>
                    <Box onClick={(event) => event.stopPropagation()}>
                        <IconButton
                            data-testid="addressRowDeleteButton"
                            aria-describedby={address.id}
                            onClick={() => confirmDelete(address.id)}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                </TableCell>
            </TableRow>
        </>
    );
};

Row.propTypes = {
    address: PropTypes.shape({
        ADDRESS: PropTypes.string,
        creation_date: PropTypes.string,
        id: PropTypes.string,
    }),
    user: PropTypes.string,
    confirmDelete: PropTypes.func,
};

const OneTimeAddressSummaryTable = ({ addresses, confirmDelete }) => {
    const user = useSelector((state) => state.auth.userName);

    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell data-testid="addressesTableHeaderId">
                            <Typography {...tableHeaderProps}>
                                Address
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography {...tableHeaderProps}>
                                Date Created
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography {...tableHeaderProps}>Owner</Typography>
                        </TableCell>
                        <TableCell>
                            <Tooltip title={TOOLTIP_ACTIONS}>
                                <Typography
                                    {...tableHeaderProps}
                                    align="center"
                                >
                                    Actions
                                </Typography>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {addresses.map((address) => (
                        <Row
                            key={address.id}
                            address={address}
                            user={user}
                            confirmDelete={confirmDelete}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

OneTimeAddressSummaryTable.propTypes = {
    addresses: PropTypes.arrayOf(
        PropTypes.shape({
            ADDRESS: PropTypes.string,
            creation_date: PropTypes.string,
            id: PropTypes.string,
        })
    ),
    confirmDelete: PropTypes.func,
};

export default OneTimeAddressSummaryTable;
